import Box from "@/components/Box";
import Circle from "@/components/Circle";
import Grid from "@/components/Grid";
import { theme } from "@/core/theme";
import { CMP_LEARNING_HUB_WEBINARS_URL } from "@/core/urls";
import { WEBINAR_CONNECTIONS_QUERY } from "@/graphql/knowledgeCenter/webinars";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import PlayIcon from "@/images/PlayIcon";
import Group from "@/tpo/Group";
import LinkWrapper from "@/tpo/LinkWrapper";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";
import { useQuery } from "@apollo/client";

import WebinarCard from "./WebinarCard";
import {
  dashboardActionButtonSize,
  dashboardCardGridGap,
  dashboardHeaderIconCircleSize,
  dashboardHeaderIconSize,
  dashboardHeaderRowGap,
  dashboardInnerStackGap,
  dashboardSectionBody,
  dashboardSectionListMaxItems,
  dashboardSectionTitle,
  learningHubDashboardWebinarCardStacked,
  lhDashboardBp
} from "./dashboardLayout";

export default function LatestWebinarsSection() {
  const { resolvedUrls } = useCmpRelatedUrl();

  const { data, loading } = useQuery(WEBINAR_CONNECTIONS_QUERY, {
    variables: {
      first: dashboardSectionListMaxItems,
      orderBy: "-start_time"
    }
  });

  const webinars = data?.webinarConnections?.edges?.map(edge => edge.node) ?? [];

  return (
    <Stack gap={dashboardInnerStackGap}>
      <Group
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={dashboardHeaderRowGap}
      >
        <Group gap={dashboardHeaderRowGap} alignItems="center" flexWrap="wrap">
          <Circle bg="transparent" size={dashboardHeaderIconCircleSize} border="2px solid black">
            <PlayIcon fill={theme.colors.dark} size={dashboardHeaderIconSize} />
          </Circle>
          <Box {...dashboardSectionTitle}>Latest webinars</Box>
        </Group>
        <ButtonV2
          color="dark"
          size={dashboardActionButtonSize}
          as={LinkWrapper}
          to={resolvedUrls[CMP_LEARNING_HUB_WEBINARS_URL]}
        >
          see all
        </ButtonV2>
      </Group>
      {!loading && !webinars.length && <Box {...dashboardSectionBody}>No webinars found</Box>}
      {!!webinars.length && (
        <Grid
          gridTemplateColumns={lhDashboardBp("1fr", "1fr", "repeat(2, 1fr)")}
          gap={dashboardCardGridGap}
          alignItems="stretch"
        >
          {webinars.map(webinar => (
            <WebinarCard
              key={webinar.id}
              {...webinar}
              stacked={learningHubDashboardWebinarCardStacked}
              header={{
                title: { fontSize: lhDashboardBp(18, 22, 24) },
                badge: { fontSize: lhDashboardBp(14, 16, 16) }
              }}
              content={{ description: { fontSize: lhDashboardBp(14, 16, 16) } }}
              button={{ size: lhDashboardBp("sm", "md", "md") }}
            />
          ))}
        </Grid>
      )}
    </Stack>
  );
}
